import { useState, useCallback, useRef, useEffect } from 'react'

interface UseToonPlayerOptions {
  totalPages: number
  autoPlayAudio?: boolean
}

export function useToonPlayer({ totalPages, autoPlayAudio = false }: UseToonPlayerOptions) {
  const [currentPage, setCurrentPage] = useState(0)
  const [direction, setDirection] = useState<'left' | 'right'>('right')
  const audioRef = useRef<HTMLAudioElement | null>(null)

  const isFirst = currentPage === 0
  const isLast = currentPage === totalPages - 1

  const goNext = useCallback(() => {
    if (currentPage < totalPages - 1) {
      setDirection('right')
      setCurrentPage((p) => p + 1)
    }
  }, [currentPage, totalPages])

  const goPrev = useCallback(() => {
    if (currentPage > 0) {
      setDirection('left')
      setCurrentPage((p) => p - 1)
    }
  }, [currentPage])

  const reset = useCallback(() => {
    setCurrentPage(0)
    setDirection('right')
  }, [])

  const playAudio = useCallback(
    (src?: string) => {
      if (!src || !autoPlayAudio) return
      const audio = audioRef.current
      if (audio) {
        audio.src = src
        audio.play().catch(() => {})
      }
    },
    [autoPlayAudio]
  )

  const playSoundEffect = useCallback((src: string) => {
    const audio = audioRef.current
    if (audio) {
      audio.src = src
      audio.play().catch(() => {})
    }
  }, [])

  // 오디오 엘리먼트 초기화
  useEffect(() => {
    audioRef.current = new Audio()
    return () => {
      if (audioRef.current) {
        audioRef.current.pause()
        audioRef.current = null
      }
    }
  }, [])

  return {
    currentPage,
    direction,
    isFirst,
    isLast,
    goNext,
    goPrev,
    reset,
    playAudio,
    playSoundEffect,
    totalPages,
  }
}
